// import React, { useState } from "react";
// import { Outlet } from "react-router-dom";
// import "./Layout.scss";
// import MainHeader from "./Header";
// import { Layout as AntLayout, theme } from "antd";
// import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
// import IconButton from "../common/IconButton";
// import UserProfile from "./UserProfile";

// const Layout = () => {
//   const {
//     token: { colorBgContainer },
//   } = theme.useToken();

//   const { Header, Content } = AntLayout;

//   const [collapsed, setCollapsed] = useState(false);

//   return (
//     <AntLayout style={{ minHeight: "100vh" }}>
//       <MainHeader collapsed={collapsed} setCollapsed={setCollapsed} />
//       <AntLayout
//         style={{
//           overflow: "auto",
//           height: "100vh",
//         }}
//       >
//         <Header
//           style={{
//             padding: 0,
//             background: colorBgContainer,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             position: "sticky",
//             top: 0,
//             right: 0,
//             zIndex: 10,
//           }}
//         >
//           <IconButton
//             type="button"
//             fillMode="flat"
//             size="small"
//             style={{
//               fontSize: "26px",
//               width: 64,
//               height: 64,
//             }}
//             onClick={() => setCollapsed(!collapsed)}
//           >
//             {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
//           </IconButton>
//           <UserProfile />
//         </Header>
//         <Content
//           style={{
//             margin: "16px",
//           }}
//         >
//           <Outlet />
//         </Content>
//       </AntLayout>
//     </AntLayout>
//   );
// };

// export default Layout;

import "./Layout.scss";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import { CiMenuBurger } from "react-icons/ci";
import UserProfile from "./UserProfile";
import { ImCross } from "react-icons/im";
import { FaCircleUser } from "react-icons/fa6";
import { SiHiveBlockchain } from "react-icons/si";
import { MdDashboard } from "react-icons/md";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { INSERT_ACCESS } from "../../_contstants/common";

const menuData = [
  {
    key: "dashboard",
    title: "Dashboard",
    icon: <MdDashboard />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "usermanagement",
    title: "User Management",
    icon: <FaCircleUser />,
    quickMenu: [
      // { title: "Menu", key: "menu" },
      // { title: "Rights", key: "rights" },
      { title: "User", key: "user" },
      { title: "User Type", key: "usertype" },
    ],
    sections: [],
  },
  {
    key: "master",
    title: "Master",
    icon: <SiHiveBlockchain />,
    quickMenu: [
      { title: "Add Shipping Movement", key: "shippingmovements/create" },
      {
        title: "Add Container Import Discharge",
        key: "containerimportdischarge/create",
      },
      {
        title: "Add Vessel's Export Loading",
        key: "vesselsexportloading/create",
      },
    ],
    sections: [
      {
        title: "Place",
        children: [
          {
            title: "Country",
            key: "country",
          },
          {
            title: "State",
            key: "state",
          },
          {
            title: "City",
            key: "city",
          },
          {
            title: "Line",
            key: "line",
          },
          {
            title: "Port",
            key: "port",
          },
        ],
      },
      {
        title: "Generals",

        children: [
          {
            title: "Agent",
            key: "agent",
          },
          {
            title: "Shipping Movements",
            key: "shippingmovements",
          },
          {
            title: "Port Import",
            key: "portimportdata",
          },
        ],
      },
    ],
  },
];

const Layout = () => {
  const navigate = useNavigate();

  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userRights: {
    menu_id: number;
    menu_key: string;
    menu_name: string;
    rights_id: string;
  }[];

  try {
    userRights = JSON.parse(userResponseString);
  } catch (error) {
    userRights = [];
  }

  const filterMenuByUserRights = (menuData: any, userRights: any) => {
    const hasRight = (key: string) => {
      if (key.includes("/create")) {
        const baseKey = key.replace("/create", "");
        const userMenu = userRights?.find(
          (menu: any) => menu.menu_key === baseKey
        );
        return (
          userMenu && userMenu.rights_id.split(", ").includes(INSERT_ACCESS)
        );
      } else {
        return userRights?.some((menu: any) => menu.menu_key === key);
      }
    };

    return menuData
      .map((menu: any) => {
        const mainMenuHasRight = hasRight(menu.key);

        if (!mainMenuHasRight) return null;

        const filteredQuickMenu = menu.quickMenu.filter((item: any) =>
          hasRight(item.key)
        );
        const filteredSections = menu.sections
          .map((section: any) => {
            const filteredChildren = section.children.filter((child: any) =>
              hasRight(child.key)
            );
            return { ...section, children: filteredChildren };
          })
          .filter((section: any) => section.children.length > 0);
        if (
          hasRight(menu.key) ||
          filteredQuickMenu.length > 0 ||
          filteredSections.length > 0
        ) {
          return {
            ...menu,
            quickMenu: filteredQuickMenu,
            sections: filteredSections,
          };
        }
        return null;
      })
      .filter((menu: any) => menu !== null);
  };

  const filteredMenus = filterMenuByUserRights(menuData, userRights);

  const toggleMenu = () => {
    document.querySelectorAll(".navbar-nav > li").forEach((element) => {
      element.addEventListener("click", function (this: HTMLElement) {
        document.querySelector(".page-contect")?.classList.remove("in");
        document.querySelectorAll(".navbar-nav > li").forEach((li) => {
          li.classList.remove("active");
          const popup = document.querySelector(
            ".navbar-nav > li.active .subnav-content"
          );
          if (popup) {
            const popupElement = popup as HTMLElement;
            popupElement.classList.remove("d-block");
            popupElement.classList.add("d-none");
          }
        });
        this.classList.add("active");
        const popup = document.querySelector(
          ".navbar-nav > li.active .subnav-content"
        );
        if (popup) {
          const popupElement = popup as HTMLElement;
          popupElement.classList.remove("d-none");
          popupElement.classList.add("d-block");
        }
      });
    });
  };

  useEffect(() => {
    toggleMenu();
  }, []);

  const toggleSubMenu = () => {
    const popup = document.querySelector(
      ".navbar-nav > li.active .subnav-content"
    );
    if (popup) {
      const popupElement = popup as HTMLElement;
      popupElement.classList.remove("d-block");
      popupElement.classList.add("d-none");
    }

    document.querySelectorAll(".navbar-nav > li").forEach((li) => {
      li.classList.remove("active");
    });
  };

  const toggleNav = () => {
    const sidenav = document.querySelector(".side-nav") as any;
    const mbottom = document.querySelector(".m-bottom") as any;
    const gmnavbarheader = document.querySelector(".gmnavbar-header") as any;
    const pagewrapper = document.querySelector(".page-wrapper") as any;
    const pagecontect = document.querySelectorAll(".page-contect") as any;
    const menuName = document.querySelectorAll(".menu-name") as any;
    const greaterThan = document.querySelector(".greaterthan") as any;
    const lessThan = document.querySelector(".lessthan") as any;

    const isOpen = sidenav.style.width === "210px";
    const isHeaderOpen = gmnavbarheader.style.width === "210px";
    sidenav.style.width = isOpen ? "60px" : "210px";
    mbottom.style.width = isOpen ? "60px" : "210px";
    pagewrapper.style.marginLeft = isOpen ? "60px" : "210px";
    gmnavbarheader.style.width = isHeaderOpen ? "60px" : "210px";
    pagecontect.forEach((element: any) => {
      if (isOpen) {
        element.style.left = "60px";
      } else {
        element.style.left = "210px";
      }
    });

    menuName.forEach((element: any) => {
      if (isOpen) {
        element.style.transition = "0.5s";
        element.classList.remove("d-inline");
        element.classList.add("d-none");
      } else {
        element.style.transition = "0.5s";
        element.classList.remove("d-none");
        element.classList.add("d-inline");
      }
    });
    if (isOpen) {
      lessThan.classList.remove("d-block");
      lessThan.classList.add("d-none");
      greaterThan.classList.remove("d-none");
      greaterThan.classList.add("d-block");
    } else {
      lessThan.classList.remove("d-none");
      lessThan.classList.add("d-block");
      greaterThan.classList.remove("d-block");
      greaterThan.classList.add("d-none");
    }
  };

  const handleNavigate = (url: string) => {
    if (url) {
      toggleSubMenu();
      navigate(`${url}`);
    }
  };

  return (
    <div id="wrapper">
      <nav className="gmnavbar" role="navigation">
        <div className="gmnavbar-header" style={{ width: 60 }}>
          <button type="button" className="navbar-toggle">
            <CiMenuBurger />
          </button>
          <h3 className="m-0">GS</h3>
        </div>
        <div className="d-flex align-items-center">
          <UserProfile />
        </div>
      </nav>
      <div className="collapse navbar-collapse navbar-ex1-collapse show">
        <ul
          className="nav navbar-nav side-nav"
          style={{ zIndex: 10, scrollbarWidth: "none", width: 60 }}
        >
          {filteredMenus.map((menu: any, index: any) => (
            <li className="subnav" key={index} onClick={toggleMenu}>
              <p
                className="collapsed"
                onClick={() => menu.key === "dashboard" && navigate("/")}
              >
                {menu.icon}
                <span className="menu-name d-none">{menu.title || ""}</span>
              </p>
              {(menu.quickMenu?.length > 0 || menu.sections?.length > 0) && (
                <div className="subnav-content page-contect">
                  <div className="container-fluid">
                    <div className="container-title">
                      <h2>{menu.title} - Quick Menu</h2>
                      <button className="model-close" onClick={toggleSubMenu}>
                        <ImCross />
                      </button>
                    </div>
                    {menu.quickMenu?.length > 0 && (
                      <div className="quick-menu">
                        <div className="quick-menu-cards">
                          {menu.quickMenu.map((item: any) => (
                            <div
                              key={item.key}
                              className="quick-menu-card"
                              onClick={() => handleNavigate(item.key)}
                            >
                              <h5>{item.title}</h5>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    <div className="section-list">
                      {menu.sections?.map(
                        (section: any) =>
                          section.children?.length > 0 && (
                            <div key={section.title} className="section">
                              <h4>{section.title}</h4>
                              <ul>
                                {section.children.map((child: any) => (
                                  <Tooltip
                                    anchorElement="target"
                                    position="top"
                                    parentTitle={true}
                                  >
                                    <li
                                      key={child.key}
                                      title={child.title}
                                      onClick={() => handleNavigate(child.key)}
                                    >
                                      {child.title}
                                    </li>
                                  </Tooltip>
                                ))}
                              </ul>
                            </div>
                          )
                      )}
                    </div>
                  </div>
                </div>
              )}
            </li>
          ))}
          <div className="m-bottom" onClick={toggleNav}>
            <a href="javascript:void(0)" className="m-arrow">
              <FaGreaterThan className="greaterthan " />
              <FaLessThan className="lessthan d-none" />
            </a>
          </div>
        </ul>
      </div>

      <div className="all-page">
        <div className="page-wrapper">
          <div className="page-information ">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
